import { RefObject } from 'react'

type UseElementRelativePositionProps = {
  elementRef: RefObject<HTMLDivElement>
}

const isBrowser = typeof window !== `undefined`

type UseElementRelativePosition = (
  props: UseElementRelativePositionProps,
) => {
  x: number
  y: number
}

const useElementRelativePosition: UseElementRelativePosition = ({
  elementRef,
}) => {
  if (!isBrowser || !elementRef) return { x: 0, y: 0 }
  const target = elementRef.current
  let position = { left: 0, top: 0 }
  if (target) {
    position = target.getBoundingClientRect()
  }

  return { x: position.left, y: position.top }
}

export default useElementRelativePosition
